import { FC } from 'react';
import { Blank, Button, Text } from '@doda/io-react/common';
import style from './index.module.scss';

/**
 * Props
 * @param title タイトルテキスト
 * @param onClick 押下処理
 */
interface Props {
  title: string;
  onClick: () => void;
}

export const SelectButton: FC<Props> = ({ title, onClick }) => {
  return (
    <Button
      variant="outline_gray"
      widthPercentage={100}
      className={style['select-button']}
      size="XS"
      onClick={onClick}
    >
      <Text as="span" size="12">
        {title}
      </Text>
      <Blank size="XXS" color="black" />
    </Button>
  );
};
